import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('ItemCategoryGroup?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('ItemCategoryGroup/show/'+id);
    },    
    create(params) {
        return Service().post('ItemCategoryGroup/create', params);
    },
    update(id, params) {
        return Service().post('ItemCategoryGroup/update/'+id, params);
    },
    delete(id) {
        return Service().post('ItemCategoryGroup/delete/'+id);
    }
}